import React, { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import MemberAvatar from "@/components/MemberAvatar";
import { useBlock } from "@/components/Safety";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Ban } from "lucide-react";

// Profile → list of members this brother has blocked, with unblock
export default function BlockedMembers() {
  const { unblock, blocked } = useBlock();
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/blocks").then((r) => setList(r.data.blocked)).catch(() => {}); }, [blocked.size]); // eslint-disable-line
  return (
    <Card className="gold-ring glass p-6 lg:col-span-3" data-testid="blocked-members-card">
      <div className="flex items-center gap-2"><Ban className="h-5 w-5 text-[hsl(var(--gold))]" /><h3 className="font-display text-lg font-700">Blocked members</h3></div>
      <p className="mt-1 text-xs text-muted-foreground">You do not see posts, comments or messages from blocked members, and they cannot message you.</p>
      {list.length === 0 ? <p className="mt-3 text-sm text-muted-foreground" data-testid="blocked-empty">You have not blocked anyone.</p> : (
        <ul className="mt-3 divide-y divide-border/60">
          {list.map((m) => <li key={m.id} className="flex items-center gap-3 py-2" data-testid={`blocked-row-${m.id}`}><MemberAvatar name={m.name} photo={m.photo_path} className="h-8 w-8" /><div className="min-w-0 flex-1"><p className="truncate text-sm font-700">{m.name}</p><p className="text-xs text-muted-foreground">{m.position} · {m.frigate || "Galleon"}</p></div><Button size="sm" variant="outline" className="gold-ring" onClick={() => unblock(m.id, m.name)} data-testid={`unblock-${m.id}`}>Unblock</Button></li>)}
        </ul>
      )}
    </Card>
  );
}
